import { verificationsApi } from '../../../data/verificationsApi';
import type { CaseSearchArgs, CaseSearchResult } from './searchViews';

/**
 * Case Search feature endpoint, injected into the single verifications base api.
 *
 * One query: `GET verificationLookup?SearchCriteria={q}&Centers={csv}`. Not cache-tagged —
 * this is a submit-scoped lookup, not an entity list that other mutations invalidate.
 */
export const searchEndpoints = verificationsApi.injectEndpoints({
  endpoints: (builder) => ({
    searchCases: builder.query<CaseSearchResult[], CaseSearchArgs>({
      query: ({ searchCriteria, centers }) => ({
        url: '/verificationLookup',
        method: 'GET',
        params: {
          SearchCriteria: searchCriteria,
          Centers: centers.length > 0 ? centers.join(',') : undefined,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useSearchCasesQuery } = searchEndpoints;
